<template>
    <div class="Retrieve">
        <div class="RetrieveBox">
            <img src="@/assets/images/Password/RetrievePassword.png" />
            <el-form :model="RetrieveForm" label-width="0" :rules="RetrieveRules" ref="RetrieveRulesForm" class="demo-ruleForm">
                <el-form-item label="" prop="customerMobile">
                    <el-input v-model.trim="RetrieveForm.customerMobile" placeholder="请输入注册时用的手机号（仅支持大陆手机号注册）" @keyup.enter.native="next"></el-input>
                </el-form-item>
                <el-form-item label="" prop="code">
                    <el-row :gutter="12">
                        <el-col :span="16">
                            <el-input v-model.trim="RetrieveForm.code" placeholder="请输入验证码" @keyup.enter.native="next"></el-input>
                        </el-col>
                        <el-col :span="8">
                            <el-button style="padding: 20px 6px; width: 100%;" size="medium" :type="Traem ? 'primary' : 'info'" :disabled="!Traem" @click="ClickGetCaptcha">{{ Ytxfont }}</el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="">
                    <el-row :gutter="12">
                        <el-col :span="16"></el-col>
                        <el-col :span="8" style="float: right;">
                            <el-button style="padding: 20px 6px; width: 100%;" type="primary" size="medium" :icon="loginLoading ? 'el-icon-loading' : ''" :disabled="loginLoading" @click="next">下一步</el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import * as API from '@/api/user';
export default {
    name: "Retrieve",
    data() {
        var validateMobile = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入手机号'));
            } else {
                if (!(/^1[3456789]\d{9}$/.test(this.RetrieveForm.customerMobile))) {
                    callback(new Error('请输入正确手机号'));
                }
                callback();
            }
        };
        return {
            RetrieveForm: {},
            RetrieveRules: {
                customerMobile: [{ validator: validateMobile, trigger: 'blur' }],
                code: [{ required: true, message: '请填写验证码', trigger: 'blur' }]
            },
            type: 'resetPassword',
            Traem: true,
            Ytxfont: "发送验证码",
            loginLoading: false
        }
    },
    methods: {
        next() {
            this.$refs.RetrieveRulesForm.validate((valid) => {
                if (valid) {
                    let params = this.RetrieveForm;
                    params.type = this.type;
                    this.loginLoading = true;
                    API.resetPasswordVerifyCode(params).then(res => {
                        this.loginLoading = false;
                        if(res.code === 20000) {
                            this.$router.push({ path: '/ResetPassword', query: { customerMobile: this.RetrieveForm.customerMobile } });
                        }
                    }).catch(err => {
                        this.loginLoading = false;
                        console.log(err);
                    });
                } else {
                    return false;
                }
            })
        },
        // 点击获取验证码
        ClickGetCaptcha() {
            if(this.RetrieveForm.customerMobile && this.RetrieveForm.customerMobile !== '') {
                if(!(/^1[3456789]\d{9}$/.test(this.RetrieveForm.customerMobile))){ 
                    this.$message({ type: 'error', message: '请输入正确手机号' });
                    return false; 
                } else {
                    let params = {
                        type: this.type,
                        customerMobile: this.RetrieveForm.customerMobile
                    }
                    this.Yanma();
                    API.sendMsgCode(params).then(res => {
                        if(res.code === 20000) {
                            console.log(res.data);
                        }
                    })
                }
            } else {
                this.$message({ type: 'error', message: '请输入手机号' });
            }
        },
        // 倒计时
        Yanma() {
            if (this.Traem) {
                let langtime = 120;
                let than = this;
                this.Traem = false;
                than.Ytxfont = `${langtime} 秒后重新发送`;
                let a = setInterval(() => {
                    if (langtime === 0) {
                        than.Traem = true;
                        than.Ytxfont = "发送验证码";
                        clearInterval(a);
                    } else {
                        than.Traem = false;
                        langtime--;
                        than.Ytxfont = `${langtime} 秒后重新发送`;
                    }
                }, 1000);
            } else {
                console.log("不能点了")
            }
        }
    }
}
</script>

<style scoped>
.Retrieve {
    border-top: 1px solid #989797;
    margin-top: 12px;
}
.Retrieve .RetrieveBox {
    margin: 0 auto;
    width: 1280px;
    margin-top: 100px;
    margin-bottom: 180px;
}
.Retrieve .RetrieveBox img {
    vertical-align: middle;
}
.Retrieve .RetrieveBox /deep/ .el-form {
    width: 668px;
    margin: 0 auto;
    margin-top: 60px
}
.Retrieve .RetrieveBox /deep/ .el-form .el-input__inner {
    line-height: 56px;
    height: 56px;
}
.Retrieve .RetrieveBox /deep/ .el-form .el-form-item {
    margin-bottom: 36px;
}
</style>